import React from 'react'

const ButtonsBlock = (props) =>
	<div className="buttons-block">{props.children}</div>

export default ButtonsBlock



// WEBPACK FOOTER //
// ./src/js/Ui/ButtonsBlock/ButtonsBlock.jsx